module.exports = __webpack_public_path__ + "img/zoom-to-loc.3694ed36.svg";